import React from "react";

function FooterHomeEight() {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <section
        className="appie-footer-area appie-footer-about-area appie-footer-8-area"
        id="contactus"
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="contact--info-area">
                <h3>Get in touch</h3>
                <p>Looking for help? Reach to us.</p>
                <div className="single-info">
                  <h5>UAE - Dubai</h5>
                  <p>
                    <i className="fal fa-home"></i>
                    Business Center, Dubai Silicon Oasis<br />
                    Dubai, UAE<br /><br />
                  </p>
                   <h5>UAE - Sharjah</h5>
                  <p>
                    <i className="fal fa-home"></i>
                    Al Hind Tower - 1510, Al Khan Corniche, <br />
                    Sharjah, UAE<br /><br />
                  </p>
                  <p>
                    <i className="fal fa-phone"></i>
                     +971 6 574 8261<br /><br />
                  </p>
                  <p>
                    <i className="fal fa-envelope"></i>
                    info@universe-media.com
                  </p>
                </div>
                <div className="single-info">
                  <h5>KSA</h5>
                  <p>
                    <i className="fal fa-home"></i>
                    Turki Ibn Abdullah Al Saud, As Sulimaniyah
 <br />
                    Riyadh , Saudi Arabia<br /><br />
                  </p>
                  <p>
                    <i className="fal fa-phone"></i>
                     +966 544 122 9337<br /><br />
                  </p>
                  <p>
                    <i className="fal fa-envelope"></i>
                    info@universe-media.com
                  </p>
                </div>
                <div className="ab-social">
                  <h5>Follow Us</h5>
                  <a className="fac" href="#">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a className="twi" href="#">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a className="you" href="#">
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a className="lin" href="#">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="bisylms-map">
                <iframe
                        title="map"
                        src=
                        // "https://maps.google.com/maps?width=720&amp;height=600&amp;hl=en&amp;coord=39.966528,-75.158284&amp;q=1%20Grafton%20Street%2C%20Dublin%2C%20Ireland+(My%20Business%20Name)&amp;ie=UTF8&amp;t=p&amp;z=16&amp;iwloc=B&amp;output=embed"  
                        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.4121900587475!2d55.371999075167906!3d25.32394597762958!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5b969b8856cd%3A0xf1b9cc7f9e07d116!2sAl%20Hind%20Tower!5e0!3m2!1sen!2sae!4v1761516947260!5m2!1sen!2sae"
                    >
                </iframe>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div
                className="
                footer-copyright
                d-flex
                align-items-center
                justify-content-between
                pt-35
              "
              >
                <div className="copyright-text">
                  <p>Copyright &copy; {currentYear} Universe Media. All rights reserved.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FooterHomeEight;
